import { FaDiscord, FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { LuExternalLink } from "react-icons/lu";
import { Link } from "react-router-dom";
import { SOCIALS_CONFIG } from "../../../config/socials_config";
import { typography } from "../../../design/tokens";
import { useSideMenuActions } from "../../../view_stores/useSideMenuStore";

const contactOptions = [
  {
    title: "Email Support",
    description: (
      <>
        <div className="mb-2">
          <br />
          Available for Grow plan users and above.
          <br />
          Covers platform-related issues only; coding and prompt-engineering
          assistance are not included.
        </div>
        Emails us at:{" "}
        <a
          href="mailto:support@darvin.dev"
          className="text-blue-400 hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          support@darvin.dev
        </a>
      </>
    ),
  },
];

export default function PersonalSettingsContact() {
  return (
    <div className="space-y-6">
      {contactOptions.map((option) => (
        <ContactOption key={option.title} option={option} isLast={false} />
      ))}

      {/* Social Media Links */}
      <div className="space-y-6">
        <div className="flex items-center gap-6 text-dark-text">
          <a
            href="https://discord.gg/Qkn5JfZMDN"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-all duration-300 border border-transparent hover:border-white p-2 rounded"
          >
            <FaDiscord className="w-6 h-6" />
          </a>
          <a
            href={SOCIALS_CONFIG.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="transition-all duration-300 border border-transparent hover:border-white p-2 rounded"
          >
            <FaLinkedin className="w-6 h-6" />
          </a>
          <a
            href={SOCIALS_CONFIG.x}
            target="_blank"
            rel="noopener noreferrer"
            className="transition-all duration-300 border border-transparent hover:border-white p-2 rounded"
          >
            <FaXTwitter className="w-6 h-6" />
          </a>
        </div>
        <hr className="border-dark-border" />
      </div>

      <ContactOption
        key={"Terms of Service"}
        option={{
          title: "Terms of Service",
          internalLink: "/terms-of-service",
        }}
        isLast={true}
      />
    </div>
  );
}

function ContactOption({
  option,
  isLast,
}: {
  option: {
    icon?: React.ReactNode;
    title: string;
    link?: string;
    internalLink?: string;
    description?: React.ReactNode;
  };
  isLast: boolean;
}) {
  const { close } = useSideMenuActions();

  const handleInternalLinkClick = () => {
    close();
  };

  return (
    <div key={option.title} className="space-y-6">
      <div className="text-dark-text flex flex-col gap-3">
        <div className={`${typography.size.base} ${typography.weight.medium} flex items-center gap-1`}>
          {option.link ? (
            <a
              href={option.link}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline flex items-center gap-1"
            >
              {option.title}
              <LuExternalLink size={16} className="ml-1" />
            </a>
          ) : option.internalLink ? (
            <Link
              to={option.internalLink}
              className="text-dark-placeholder hover:underline"
              onClick={handleInternalLinkClick}
            >
              {option.title}
            </Link>
          ) : (
            <span>{option.title}</span>
          )}
        </div>
        {option.description && (
          <div className={`${typography.size.sm} ${typography.weight.light}`}>{option.description}</div>
        )}
      </div>
      {!isLast && <hr className="border-dark-border" />}
    </div>
  );
}
